import { render, staticRenderFns } from "./BrightReport2.vue?vue&type=template&id=e2dc8f16"
import script from "./BrightReport2.vue?vue&type=script&lang=js"
export * from "./BrightReport2.vue?vue&type=script&lang=js"
import style0 from "./BrightReport2.vue?vue&type=style&index=0&id=e2dc8f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports